import { Connection } from '@solana/web3.js';

// Sunset RPC: same VITE_RPC_URL the main app reads (see App.tsx). Never
// hardcode a provider key here — it ships in the bundle. Falls back to the
// public endpoint if the env var is missing.
const DEFAULT_RPC = 'https://api.mainnet-beta.solana.com';

const RPC_URL =
  (import.meta.env.VITE_RPC_URL as string | undefined) || DEFAULT_RPC;

let cached: Connection | null = null;

export function getConnection(): Connection {
  if (!cached) {
    cached = new Connection(RPC_URL, { commitment: 'confirmed' });
  }
  return cached;
}

export const NETWORK_LABEL =
  (import.meta.env.VITE_NETWORK_LABEL as string | undefined) ?? 'mainnet';
